import React from 'react';
import { Grid } from 'e100-react-components';
import { useStyles } from './styles';
import { AutoIcon, CarLicense, LocationPosition } from './components';

import { UserLocation } from 'entities/users/types';
import { useMyFleetOperations } from 'features/myFleet';
import { logAmplitudeEvent } from 'shared/utils/amplitude/amplitude';

interface UserCurrentLocationCardProps {
  currentLocationData: UserLocation;
}

export const UserCurrentLocationCard = (props: UserCurrentLocationCardProps) => {
  const { currentLocationData } = props;

  const { cardNumber, autoNumber, latitude, longitude, storeTimestampUtc } = currentLocationData;
  const { setSelectedMobileLocation } = useMyFleetOperations();

  const classes = useStyles();
  return (
    <button
      className={classes.button}
      onClick={() => {
        logAmplitudeEvent('clickE100Mobile', {
          extra: {
            cardNumber,
          },
        });
        setSelectedMobileLocation(currentLocationData);
      }}
    >
      <Grid
        container
        classes={{
          root: classes.contentRoot,
        }}
        spacing={0}
      >
        <Grid item>
          <AutoIcon lastActivityDate={storeTimestampUtc} />
        </Grid>
        <Grid item classes={{ root: classes.itemText }}>
          <Grid container direction="column" spacing={0}>
            <Grid item classes={{ root: classes.itemPadding }}>
              <CarLicense licensePlate={autoNumber} />
            </Grid>
            <Grid item classes={{ root: classes.itemPadding }}>
              <LocationPosition latitude={latitude} longitude={longitude} />
            </Grid>
            <Grid item>
              <Grid container>
                <Grid item>{cardNumber}</Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </button>
  );
};
